export const jsapiMap = {
  toast: {
    replaceName: 'showToast',
  },
  confirm: {
    replaceOptionKey: {
      message: 'content',
      okButton: 'confirmButtonText',
      cancelButton: 'cancelButtonText',
    },
  },
  alert: {
    replaceOptionKey: {
      message: 'content',
      button: 'buttonText',
    },
  },
  getCurrentLocation: {
    replaceName: 'getLocation',
  },
  request: {
    arrayToObject: ['headers'],
    //   overwriteOptionValue: {
    //     url: getProxyUrl(),
    //   },
    // },
  },
};
